import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MessageErrorResolver } from '../../utilities/message-error-resolver';
import { LoadingService } from './loading.service';
import { EMPTY, Observable, catchError, map } from 'rxjs';
import { IPage } from '../../models/pagination/page';
import { ISportDto } from '../../models/sport-dto';
import { ResponseDto, ResponseWithErrorDto } from '../../models/exceptions/response-dto';

@Injectable({
  providedIn: 'root'
})
export class SportService {

  private url: string = environment.apiUrl + "/v1/esportes";

  constructor(private httpClient: HttpClient,
    private messageErrorResolver: MessageErrorResolver,
    private loadingService: LoadingService) {
  }

  search(
    searchText: string = '',
    page: number = 0,
    size: number = 10
  ): Observable<IPage<ISportDto>> {
    let params = new HttpParams();
    if (size) params = params.set("size", size);
    if (page >= 0) params = params.set("page", page);
    if (searchText) params = params.set("espTxDescricao", searchText);

    return this.httpClient.get<ResponseDto<IPage<ISportDto>>>(this.url, { params })
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.loadingService.deactivate()
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        }),
      );
  }

  public getAllEsportByBlocoCompId(bloNrId: number, page?: number, size?: number, searchText?: string): Observable<IPage<ISportDto>> {
    let params = new HttpParams();
    if (page) params = params.set("page", page);
    if (size) params = params.set("size", size);
    if (searchText) params = params.set("espTxDescricao", searchText);
    return this.httpClient.get<ResponseDto<IPage<ISportDto>>>(this.url + `/${bloNrId}/esportes`, { params })
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.messageErrorResolver.resolveMessage(error);
          this.loadingService.deactivate();
          return EMPTY;
        })
      );
  }

  public getAllSports(page?: number, size?: number, searchText?: string): Observable<IPage<ISportDto>> {
    let params = new HttpParams();
    if (page !== undefined) params = params.set("page", page);
    if (size) params = params.set("size", size);
    if (searchText) params = params.set("espTxDescricao", searchText);

    return this.httpClient.get<ResponseDto<IPage<ISportDto>>>(this.url, { params })
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        })
      );
  }


  public getSportById(espNrId: number): Observable<ISportDto> {

    return this.httpClient.get<ResponseDto<ISportDto>>(`${this.url}/${espNrId}`)
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        })
      );
  }

}
